import { IProductDTO } from '@legacy/shared-types/dto/product.type';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlProductApi } from '@api/product/btlProductApi';
export const useBtlProductByAppId = (appId?: string): UseQueryResult<IProductDTO[]> =>
  useQuery(['btl-products-list', appId], () => (appId ? btlProductApi.getBtlProductsByAppId(appId) : {}), {
    enabled: !!appId,
  });
